import setFullbanner from './home/1_fullbanner';
import setIconsVertical from './home/icons_vertical';
import setCarousel from '../components/carousel';
import setReviewsSwiper from './home/reviews';
import setSliderGrids from './home/4_categories';

//addImports

import setTopBar from '../components/topBar';
import handleConditionalLazy from '../components/conditionalLazy';

const Home = {
  init: function () {
    setTopBar();
    handleConditionalLazy();

    setFullbanner()
		setIconsVertical();
		setCarousel();
		setReviewsSwiper();
		setSliderGrids();
		
		//calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
});
